import _ from 'lodash';
import { RegionKeys } from 'src/core/provider/AppMeta';
import { fromJsonArray } from 'src/core/utils';
import Pageable from 'src/entities/basic-types/Pageable';
import DirectCustomer from 'src/entities/success-list/DirectCustomer';
import SuccessListEntry from 'src/entities/success-list/SuccessListEntry';
import SuccessListEntryHistory from 'src/entities/success-list/SuccessListEntryHistory';
import SuccessListOverview from 'src/entities/success-list/SuccessListOverview';
import SuccessListTopic from 'src/entities/success-list/SuccessListTopic';
import { entityCollectionDefaultState, EntityCollectionState } from 'src/store/entities/types/EntityCollectionState';
import { singleEntityDefaultState, SingleEntityState } from 'src/store/entities/types/SingleEntityState';

/*  Direct Customers  */
export const getDirectCustomers = (state: any): EntityCollectionState<DirectCustomer> => {
    const data = state.directCustomers;

    if (_.isEmpty(data)) return entityCollectionDefaultState<DirectCustomer>();

    return {
        isFetching: data.isFetching,
        error: data.error,
        items: fromJsonArray(DirectCustomer, data.items),
    };
};

/* Success List Overview */
export const getSuccessListOverview = (state: any): EntityCollectionState<SuccessListOverview> => {
    const data = state.successListOverview;

    if (_.isEmpty(data)) return entityCollectionDefaultState<SuccessListOverview>();

    return {
        isFetching: data.isFetching,
        error: data.error,
        items: fromJsonArray(SuccessListOverview, data.items),
    };
};

/* Success List Topics */
export const getSuccessListTopics = (state: any): EntityCollectionState<SuccessListTopic> => {
    const data = state.successListTopics;

    if (_.isEmpty(data)) return entityCollectionDefaultState<SuccessListTopic>();

    return {
        isFetching: data.isFetching,
        error: data.error,
        items: fromJsonArray(SuccessListTopic, data.items).sort((a, b) => a.sortOrder - b.sortOrder),
    };
};

/* Success List */
export const getSuccessList = (state: any): SingleEntityState<Pageable<SuccessListEntry>> => {
    const data = state.successListEntries;

    if (_.isEmpty(data)) return singleEntityDefaultState<Pageable<SuccessListEntry>>();

    return {
        isFetching: data.isFetching,
        error: data.error,
        content: data.content ? new Pageable(SuccessListEntry, data.content) : undefined,
    };
};

/* Success List */
export const getSuccessListEntryHistory = (state: any): EntityCollectionState<SuccessListEntryHistory> => {
    const data = state.successListEntryHistory;

    if (_.isEmpty(data)) return entityCollectionDefaultState<SuccessListEntryHistory>();

    return {
        isFetching: data.isFetching,
        error: data.error,
        items: fromJsonArray(SuccessListEntryHistory, data.items),
    };
};

/* Success List Regions */
export const getSuccessListRegions = (state: any): EntityCollectionState<RegionKeys> => {
    const data = state.successListRegions;

    if (_.isEmpty(data)) return entityCollectionDefaultState<RegionKeys>();

    return {
        isFetching: data.isFetching,
        error: data.error,
        items: data.items ?? [],
    };
};
